import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-conformado',
  templateUrl: './conformado.component.html',
  styleUrls: ['./conformado.component.css']
})
export class ConformadoComponent implements OnInit {
  public motivo:string='';
  constructor() { }

  ngOnInit(): void {
  }
  enviar(){

  }
  cancelar(){
    this.motivo='';
  }

}
